import React from 'react';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {connect} from 'react-redux';
import {selectQuickTexts} from '../../redux/selectors/quickText.selector';
import {IconButton} from '../IconButton';
import {QuickTextsIcon} from '../../utils/icons';
import {Menu, MenuItem} from '@mui/material';
import {useTranslation} from 'react-i18next';


const QuickTextPicker = props => {
    const [t] = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [el, setEl] = React.useState();
    const {
        quickTexts,
        onChange,
        currentValue
    } = props;

    return (<>
            <IconButton
                tooltip={t('quickTexts')}
                onClick={() => setOpen(true)}
                onRef={setEl}
                size="large">
                <QuickTextsIcon/>
            </IconButton>
            <Menu
                anchorEl={el}
                keepMounted
                open={open}
                onClose={() => setOpen(false)}
            >
                {quickTexts.sortBy(q => +q.index).map(q => (
                    <MenuItem
                        title={q.get('text')}
                        onClick={() => {
                            if(currentValue) {
                                onChange(`${currentValue} ${q.get('text')}`);
                            } else {
                                onChange(q.get('text'));
                            }
                        }}
                        key={q.id}>{q.get('text')}</MenuItem>
                ))}
            </Menu>
        </>
    );
};

function mapDispatchToProps() {
    return {};
}

const mapStateToProps = createStructuredSelector({
    quickTexts: selectQuickTexts
});
export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(QuickTextPicker);